export default "__VITE_ASSET__omvwGUai__"